module.exports = __webpack_public_path__ + "img/Cloud-background.11452cab.png";